import React, { useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Drawer from '@material-ui/core/Drawer';
import Button from '@material-ui/core/Button';
import { Box } from '@material-ui/core';
import { translate } from 'components/Translation';
import { useLocation } from 'react-router-dom';
import LanguageSwitcher from 'components/LanguageSwitcher/LanguageSwitcher';

const useStyles = makeStyles((theme) => ({
	list: {
		width: 250,
	},
	fullList: {
		width: '100vw',
		[theme.breakpoints.up('sm')]: {
			maxWidth: '320px',
		},
	},
	closeIcon: {
		width: '2rem',
		height: '2rem',
		cursor: 'pointer',
	},
}));

type Anchor = 'top' | 'left' | 'bottom' | 'right';

type NavigationDrawerProps = {
	children: React.ReactNode;
};

function NavigationDrawer({ children }: NavigationDrawerProps) {
	const classes = useStyles();
	const [state, setState] = React.useState({
		left: false,
	});
	const location = useLocation();

	const toggleDrawer = (anchor: Anchor, open: boolean) => (event: React.KeyboardEvent | React.MouseEvent) => {
		if (
			event.type === 'keydown' &&
			((event as React.KeyboardEvent).key === 'Tab' || (event as React.KeyboardEvent).key === 'Shift')
		) {
			return;
		}

		setState({ ...state, [anchor]: open });
	};

	useEffect(() => {
		setState({ ...state, left: false });
	}, [location]);

	return (
		<Box>
			<Button
				onClick={toggleDrawer('left', true)}
				className="d-sm-none d-flex"
				data-testid="drawer"
				aria-label={translate('nav.menu')}
			>
				<img src="/menu.svg" height={24} width={24} alt="" role="presentation" />
			</Button>
			<Drawer anchor={'left'} open={state['left']} onClose={toggleDrawer('left', false)}>
				<Box className="close-button">
					<Button onClick={toggleDrawer('left', false)} aria-label={translate('close')}>
						<img src="/close.svg" alt="" role="presentation" />
					</Button>
				</Box>
				<Box className={classes.fullList}>
					{children}
					<LanguageSwitcher />
				</Box>
			</Drawer>
		</Box>
	);
}

export default NavigationDrawer;
